// import { disclaimerModal } from './components/disclaimerModal';
import { mobileMenu } from './components/mobileMenu';
import { desktopMenu } from './components/desktopMenu';
import { gforms } from './components/gforms';
// Block patterns
import { patternAccordionFaqs } from './components/patternAccordion';
import { patternManifesto } from './components/patternManifesto';
import { patternStoryExchange } from './components/patternStoryExchange';
import { patternTestimonials } from './components/patternTestimonials';
import { video } from './components/video';
import { patternTimeline } from './components/patternTimeline';
import { patternBooks } from './components/patternBooks';
import { patternBullets } from './components/patternBullets';
import { regionalMap } from './components/regionalMap';
import { patternBiographyGrid } from './components/patternBiographyGrid';
import { featureSwiper } from './components/featureSwiper';
import { reachGallery } from './components/reachGallery';
import { patternFeaturedCaseStudies } from './components/patternFeaturedCaseStudies';
import { dropdowns } from './components/dropdowns';
import { regionPopup } from './components/regionPopup';

// Shortcodes
import { codeCareers } from './components/codeCareers';
import { codeNews } from './components/codeNews';
import { codePeople } from './components/codePeople';
import { codeProjects } from './components/codeProjects';
import { codeResources, codeTools } from './components/codeResources';
import { scrollFX } from './components/scrollFX';
import ioAnimations from './components/ioAnimations';
import { signupPopup } from './components/signupPopup';
import { heroVideo } from './components/heroVideo';

import { newsletterPopup } from './components/newsletterPopup';
import { eventStock } from './components/eventStock';
import { campaignGallery } from './components/campaignGallery';
import { donorScroll } from './components/donorScroll';
import { dropdownDonation } from './components/dropdownDonation';
import { event } from 'jquery';
import { timezoneConverter } from './components/timezoneConverter';
import { addToCalendarPopup } from './components/addToCalendarPopup';
import { autocompleteSchool } from './components/autocompleteSchool';
import { shareNSNPopup } from './components/shareNSNPopup';
import { patternTestimonialsCards } from './components/patternTestimonialsCards';

$(() => {
  // disclaimerModal();
  mobileMenu();
  desktopMenu();
  dropdowns();
  gforms();
  featureSwiper();
  reachGallery();
  video();

  // patterns
  patternAccordionFaqs();
  // patternAccordionProjects();
  patternManifesto();
  patternStoryExchange();
  patternTestimonials();
  patternTimeline();
  patternBooks();
  patternBullets();
  regionalMap();
  patternBiographyGrid();
  patternFeaturedCaseStudies();
  signupPopup();
  heroVideo();
  // regionPopup();

  // shortcodes
  codeCareers();
  codeNews();
  codePeople();
  codeProjects();
  codeResources();
  codeTools();

  //animation
  scrollFX();
  ioAnimations();

  newsletterPopup();
  eventStock();
  campaignGallery();
  donorScroll();
  dropdownDonation();
  timezoneConverter();
  addToCalendarPopup();
  autocompleteSchool();
  shareNSNPopup();
  patternTestimonialsCards();
});
